import { getAmplitudeInstance } from '../amplitudeHelpers';
import VisitationDay from '../enums/VisitationDay';

type logTrailDetailsVisitationDaySelectedParams = {
  trail_id: number;
  visitation_day_selected: VisitationDay;
};

/**
 * User select a day in Visitation module (hovering over a day does not trigger any info change).
 * @param params - Attributes to log with the amplitude event
 * @param params.trail_id - The trail id of the associated trail details page.
 * @param params.visitation_day_selected - Day selected or hovered over by user in Visitation module.
 */
const logTrailDetailsVisitationDaySelected = (
  { trail_id, visitation_day_selected }: logTrailDetailsVisitationDaySelectedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'trail details visitation day selected',
    { 'trail id': trail_id, 'visitation day selected': visitation_day_selected },
    callback
  );
};

export default logTrailDetailsVisitationDaySelected;
